import React from 'react';
import CustomModal from "../../../components/Modal/CustomModal";
import ResidentWhiteListTabs from "../SubComponents/Residents/ResidentWhiteListTabs";
import { AddToWhiteListModalApp } from "../Functionality/AddToWhiteListModalApp";
import {IconAreaTable} from "../../../components/buttons/IconButtons";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Modal opened from the white list tab to add residents to the white list of the
 * building, it only holds the automatic and manual tabs.
 *
 * @param {boolean} props.show - Modal visibility.
 * @param {Function} props.onHide - Closes the modal.
 * @param {Function} props.onSaved - Notifies the white list tab so it reloads its list.
 * @param {string} props.buildingId - Building the residents are authorized in.
 */
const AddToWhiteListModal = ({
    show,
    onHide,
    onSaved,
    buildingId
}) => {

    const {
        t,
        emptyFields,
        setEmptyFields,
        displayModal,
        setDisplayModal,
        photoPickerFile,
        setPhotoPickerFile,
        whiteListDetail,
        setWhiteListDetail,
        handleClose,
        handleSaveWhiteList
    } = AddToWhiteListModalApp({
        show,
        onHide,
        onSaved,
        buildingId
    });

    return (
        <CustomModal show={show}
                     size='lx'
                     display={displayModal}
                     onConfirm={handleSaveWhiteList}
                     onHide={handleClose}
                     classNameBody="pt-2"
                     topLeftHeader={
                         <div className='d-flex align-items-center pb-3'>
                             <div><IconAreaTable /></div>
                             <p className='fs-24px ibl-font-w-600 font-color-general-950 font-color-primary-600 ml-2'>
                                 {t('add_to_white_list')}
                             </p>
                         </div>
                     }
        >
            <div className='row'>
                <ResidentWhiteListTabs
                    emptyFields={emptyFields}
                    setEmptyFields={setEmptyFields}
                    setDisplayModal={setDisplayModal}
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    whiteListDetail={whiteListDetail}
                    setWhiteListDetail={setWhiteListDetail}
                />
            </div>

        </CustomModal>

    );

}

export default AddToWhiteListModal
